import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import store from "./store";
import router from "./router";
import Vuelidate from "vuelidate";

import { APIDataSource } from "./utilities/APIDataSource";

import i18n from './i18n'

Vue.config.productionTip = false

Vue.use(Vuelidate);

new Vue({
  data: {
    notifyBus: new Vue(),
  },
  provide: function () {
    return {
      notifyBus: this.notifyBus,
      dataSource: new APIDataSource(this.notifyBus)
    }
  },

  store,
  router,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
